import { useMemo } from 'react';

import { useFrontendConfiguration } from '@rover/rsdk/src/modules/Data/Core/FrontendConfiguration';

import { RoverStatsigUser } from '../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useRoverStatsigUser(initialUserAttributes?: Record<string, any>): {
  roverStatsigUser: RoverStatsigUser;
  isLoading: boolean;
  error: Error | null;
} {
  const { settings: frontendConfigSettings, isLoading, error } = useFrontendConfiguration();
  const apiUserAttributes = frontendConfigSettings?.experimentUserAttributes;

  // Prefer initial attributes (from server context) over API attributes
  const experimentUserAttributes = initialUserAttributes ?? apiUserAttributes;

  const roverStatsigUser: RoverStatsigUser = useMemo(() => {
    if (!experimentUserAttributes) return {};
    return {
      userID: experimentUserAttributes.userId ?? undefined,
      email: experimentUserAttributes.email ?? undefined,
      country: experimentUserAttributes.country ?? undefined,
      ip: experimentUserAttributes.ip ?? undefined,
      userAgent: experimentUserAttributes.userAgent ?? undefined,
      appVersion: experimentUserAttributes.appVersion ?? undefined,
      locale: experimentUserAttributes.locale ?? undefined,
      custom: {
        ...experimentUserAttributes.custom,
      },
      customIDs: {
        // Output snake_case keys to match Statsig console configuration
        // Handle both camelCase (from API) and snake_case (from context with blocklist) as input
        rover_cid:
          experimentUserAttributes.customIds?.roverCid ??
          experimentUserAttributes.customIds?.rover_cid,
        environment_id:
          experimentUserAttributes.customIds?.environmentId ??
          experimentUserAttributes.customIds?.environment_id,
      },
    };
  }, [experimentUserAttributes]);

  // If we have initial attributes, don't show loading state
  const effectiveLoading = initialUserAttributes ? false : isLoading;

  return { roverStatsigUser, isLoading: effectiveLoading, error };
}
